import {AfterViewInit, Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import { StorageService } from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import { NotificationService } from '../../../Services/notification.service';
import { Title } from '@angular/platform-browser';
import { ResponseModel } from '../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {WorkorderDocumentService} from '../../../Services/workorder-document.service';
import {WoInvoicingService} from '../../../Services/wo-invoicing.service';
import {TransactionEntityService} from '../../../Services/transaction-entity.service';
import {Modal} from 'bootstrap';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-work-orders-list',
  templateUrl: './work-orders-list.component.html',
  styleUrls: ['./work-orders-list.component.css'],
  standalone: false
})
export class WorkOrdersListComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private titleService: Title,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    public confirmDialog: ConfirmDialogService,
    private workorderDocs: WorkorderDocumentService,
    private invoicingService: WoInvoicingService,
    private entityService: TransactionEntityService,
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  /**
   * Returns a Bootstrap text class for due-date style rules.
   * - Success if completed_date exists
   * - Danger if days until target <= 5
   * - Warning if days until target <= 10
   * - Regular text otherwise
   */
  getDueClass(targetDate: any, completedDate: any): string {
    try {
      if (completedDate) {
        return 'text-success';
      }
      if (!targetDate) {
        return '';
      }
      const today = new Date();
      const target = new Date(targetDate);
      // zero out time for both to compare in whole days
      const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const t1 = new Date(target.getFullYear(), target.getMonth(), target.getDate());
      const msPerDay = 24 * 60 * 60 * 1000;
      const diffDays = Math.ceil((t1.getTime() - t0.getTime()) / msPerDay);
      if (diffDays <= 5) {
        return 'text-danger';
      }
      if (diffDays <= 10) {
        return 'text-warning';
      }
      return '';
    } catch {
      return '';
    }
  }

  recId = '';

  vm: any = {
    title: 'Work Orders',
    formUrl: '/work-orders/work-orders-form',
    invoiceFormUrl: '/transactions/invoice/ar/form',
    workorderFilter: {},
    list: {},
    listWithoutFilter: {},
    Preferences: {},
    permissions: {},
    workorderSearch: '',
    workorderToDate: '',
    workorderFromDate: '',
    workorderNumberOfResults: '25',
    incompleteWorkOrders: '',
    workorderStatus: '',
    notInvoiced: '',
    assignedToMe: '',
    searching: false,
    filterOptions: ['All', 'Completed', 'In Progress', 'Open', 'Emergency'],
  };

  isLoaded = false;
  // controls the global preloader while printing from list
  printing = false;
  // controls the global preloader while building email payload
  emailing = false;
  // controls the global preloader while generating an invoice from the list
  invoicing = false;

  // Email modal payload
  reportDataToSendInEmail: any = {};

  workOrdersCount = 0;
  today = new Date();


  selectedFilterOption = null;

  ngOnInit() {
    this.vm.list = [];
    this.restorePagerState();
    this.dataInit();
    this.getList();
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  ngOnDestroy(): void {
    // no legacy datatable resources to clean
  }

  stringDateConvert(date: string): Date {
    return new Date(date);
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  getAssignedToMeData(e) {
    this.vm.workorderFilter.assignedToMe = e;
    this.getPagedApiData();
  }

  geNotInvoicedData(e) {
    this.vm.notInvoiced = e;
    this.getPagedApiData();
  }

  filterByStatus(e, status = 'All') {
    if (e && status !== 'All') {
      const list = [...this.vm.listWithoutFilter];
      const filteredList = list.filter((obj) => obj.status == status);
      this.vm.list = filteredList;
    } else {
      this.vm.list = this.vm.listWithoutFilter;
    }
  }

  dataInit() {
    this.vm.workorderFilter = this.localStorage.StorageGet('workorderFilter', {
      text: '',
      sort: 'number',
      ascending: true,
      assignedToMe: false,
      status: '',
    });
    if (typeof this.vm.workorderFilter === 'string') {
      this.vm.workorderFilter = JSON.parse(this.vm.workorderFilter);
    }
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences', ''));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));

    if (this.vm.notInvoiced === 'true') {
      this.vm.notInvoiced = true;
    }
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
    if (!this.vm.permissions.Admin) {
      this.vm.assignedToMe = this.localStorage.StorageGet('assignedToMe', true);
    } else {
      this.vm.assignedToMe = this.localStorage.StorageGet('assignedToMe', '');
    }
  }

  encodeQueryData(data, filterEmpty = true) {
    const ret = [];
    for (const d in data) {
      if (filterEmpty) {
        if (data[d] != null && data[d] != '') {
          ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
        }
      } else {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  getList() {
    const listParams = {
      fromDate: this.vm.workorderFromDate,
      toDate: this.vm.workorderToDate,
      search: this.vm.workorderSearch,
      incompleteWorkOrders: this.vm.incompleteWorkOrders,
      notInvoiced: this.vm.notInvoiced,
      numberOfResults: this.vm.workorderNumberOfResults,
      assignedToMe: this.vm.workorderFilter.assignedToMe,
      status: this.vm.workorderStatus,
      pageNumber: this.page !== 0 ? this.page - 1 : 0,
      pageSize: this.pageSize,
    };
    this.tableDataService
      .getApiListData('WorkOrder', '?' + this.encodeQueryData(listParams, false))
      .subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        // console.log(JSON.stringify(this.vm.list));
        this.vm.listWithoutFilter = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.isLoaded = true;
        this.vm.searching = false;
        this.workOrdersCount = result.totalRecords;
        for (const [x, value] of Object.entries(this.vm.list)) {
          if (this.vm.list[x].required_by_date && !this.vm.list[x].completed_date) {
            const d = new Date();
            const tempRequiredDate = new Date(this.vm.list[x].required_by_date);
            if (tempRequiredDate < d) {
              this.vm.list[x].requiredPast = true;
            }
          }
        }
      });
  }

  generateInvoice(row: any) {
    const messages: string[] = [
      $localize`:Generate Invoice? @@generateInvoice:Generate Invoice?`,
      '',
    ];
    this.confirmDialog.confirmThis(
      messages,
      () => {
        // fall thru on yes
        this.generateInv(row);
      },
      () => {
        this.notification.success($localize`:Canceled @@Canceled:Canceled`);
        return;
      }
    );
  }

  async generateInv(row: any) {
    this.invoicing = true;
    try {
      let customerEmail: string | null = null;
      if (row.entity_id) {
        try {
          const ctx = await firstValueFrom(this.entityService.loadEntityContext(row.entity_id));
          customerEmail = ctx?.primaryContact?.email ?? null;
        } catch {
          // Non-fatal — invoice will still be created without an email
        }
      }
      const result = await this.invoicingService.invoiceWorkOrder({
        workorderId: row.id,
        entityId: row.entity_id,
        customerEmail,
        woNumber: row.number,
      });
      if (result.success) {
        this.notification.success($localize`:Invoice created successfully.@@invoiceCreatedSuccessfully:Invoice created successfully.`);
        this.getList();
      } else {
        this.notification.error(result.error ?? $localize`:Error generating invoice.@@errorGeneratingInvoice:Error generating invoice.`);
      }
    } finally {
      this.invoicing = false;
    }
  }

  search() {

    this.getList();
  }


  async onNavigate(aID: any, print = false) {
    if (print) {
      // Direct print using document service, show preloader until fully ready
      try {
        this.printing = true;
        await this.workorderDocs.printById(String(aID));
      } catch (e) {
        // error toast handled in service
      } finally {
        this.printing = false;
      }
      return;
    }
    this.router.navigate([this.vm.formUrl], {queryParams: {workorderId: aID}}).then();
  }

  /** Build EmailModel for selected Work Order id and open the shared Send Email modal */
  async email(id: any) {
    try {
      this.emailing = true;
      const emailObj = await this.workorderDocs.buildEmailModelById(String(id));
      this.reportDataToSendInEmail = emailObj;
      const el = document.getElementById('sendEmailModal');
      if (el) {
        const modal = Modal.getOrCreateInstance(el);
        modal.show();
      }
    } catch (e) {
      console.error('Unable to open email modal for work order id:', id, e);
      // Fall back to a generic notification service if available
      try {
        (this.notification as any)?.showErrorToast?.($localize`:Unable to prepare email@@unableToPrepareEmail:Unable to prepare email`);
      } catch {
      }
    } finally {
      this.emailing = false;
    }
  }

  // ----------------- Server side paging --------------------

  getPagedApiData() {
    const listParams = {
      fromDate: this.vm.workorderFromDate,
      toDate: this.vm.workorderToDate,
      search: this.vm.workorderSearch,
      incompleteWorkOrders: this.vm.incompleteWorkOrders,
      notInvoiced: this.vm.notInvoiced,
      numberOfResults: this.vm.workorderNumberOfResults,
      assignedToMe: this.vm.workorderFilter.assignedToMe,
      status: this.vm.workorderStatus,
      pageNumber: this.page !== 0 ? this.page - 1 : 0,
      pageSize: this.pageSize,
    };
    this.tableDataService
      .getApiListData('WorkOrder', '?' + this.encodeQueryData(listParams, false))
      .subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.vm.listWithoutFilter = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.isLoaded = true;
        this.vm.searching = false;
        for (const [x, value] of Object.entries(this.vm.list)) {
          if (this.vm.list[x].required_by_date && !this.vm.list[x].completed_date) {
            const d = new Date();
            const tempRequiredDate = new Date(this.vm.list[x].required_by_date);
            if (tempRequiredDate < d) {
              this.vm.list[x].requiredPast = true;
            }
          }
        }
      });
  }

  serverSearch(value) {
    this.vm.workorderSearch = value.searchTerm;
    this.vm.workorderFromDate = value.fromDate;
    this.vm.workorderToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.workorderSearch = value.searchTerm;
    this.vm.workorderFromDate = value.fromDate;
    this.vm.workorderToDate = value.toDate;
    this.page = 1;
    this.vm.incompleteWorkOrders = '';
    this.vm.workorderNumberOfResults = '25';
    this.vm.workorderStatus = '';
    this.vm.assignedToMe = false;
    this.vm.notInvoiced = false;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
